import { StyleSheet, Platform } from 'react-native';
import { JDDevice } from '@jdreact/jdreact-core-lib';
import Steep from '../../utils/steep';

const { NAVIGATION_BAR_HEIGHT, SYS_BAR_HEIGHT } = Steep;
// const BACKGROUND_TOP = Platform.OS === 'android' ? -SYS_BAR_HEIGHT :0

const styles = StyleSheet.create({
  navigationBarContainer: {
    position: 'absolute',
    top: 0,
    width: '100%',
    // width: JDDevice.getRpx(750),
    height: NAVIGATION_BAR_HEIGHT + SYS_BAR_HEIGHT,
    left: 0,
    zIndex: 999,
    // paddingTop: SYS_BAR_HEIGHT,
  },
  navigationBar: {
    height: NAVIGATION_BAR_HEIGHT + SYS_BAR_HEIGHT,
    paddingTop: SYS_BAR_HEIGHT,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  bg: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    // width: JDDevice.getRpx(750),
    height: NAVIGATION_BAR_HEIGHT + SYS_BAR_HEIGHT,
  },
  left: {
    width: NAVIGATION_BAR_HEIGHT,
    height: NAVIGATION_BAR_HEIGHT,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
  },
  middle: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  right: {
    width: NAVIGATION_BAR_HEIGHT,
    height: NAVIGATION_BAR_HEIGHT,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
  },
  navBtn: {
    width: NAVIGATION_BAR_HEIGHT,
    height: NAVIGATION_BAR_HEIGHT,
    justifyContent: 'center',
    alignItems: 'center',
  },
  backIcon: {
    width: 9,
    height: 16,
  },
  titleText: {
    fontSize: JDDevice.getFontSize(36),
    color: '#fff',
    textAlign: 'center',
    backgroundColor: 'transparent',
  },
  moreIcon: {
    width: 18,
    height: 3.6,
    resizeMode: 'stretch',
  },
});

export default styles;
